document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.announcement-bar');
    if (!wrapper) return;

    let items = wrapper.querySelectorAll('.top-item:not(.hide-on-desktop)');
    if (window.innerWidth < 768) {
        items = wrapper.querySelectorAll('.top-item:not(.hide-on-mobile)');
    }

    if (!items.length) return;

    const speedAttr = wrapper.getAttribute('data-speed');
    const intervalTime = (parseFloat(speedAttr) || 5) * 1000;

    items[0] && items[0].classList.add('active');

    let activeIndex = 0;
    if (items.length > 1) {
        setInterval(() => {
            const current = items[activeIndex];
            const nextIndex = (activeIndex + 1) % items.length;
            const next = items[nextIndex];

            if (!current || !next) return;

            current.style.transition = 'none';
            current.classList.remove('active');

            void current.offsetWidth;
            current.style.transition = '';

            next.classList.add('active');
            activeIndex = nextIndex;
        }, intervalTime);
    }
});